import { useEffect, useState } from "react";
const getNavbarPosition = () => {
    const navbar = document.getElementById("navigation-bar");
    if (!navbar)
        return "";
    const navbarRect = navbar.getBoundingClientRect();
    const position = navbarRect.top > 140 ? "" : "sticky";
    return position;
};
export const useIsNavbarSticky = (isNavigationBar) => {
    const [isSticky, setIsSticky] = useState(false);
    useEffect(() => {
        const handleScroll = () => {
            const position = getNavbarPosition();
            setIsSticky(position === "sticky");
        };
        isNavigationBar && window.addEventListener("scroll", handleScroll);
        return () => {
            isNavigationBar && window.removeEventListener("scroll", handleScroll);
        };
    }, [isNavigationBar]);
    return isSticky;
};
